import { isNil } from "ramda"
import { useEffect } from "react"
import { IColumnsVisibility } from "../components/TableColumns"
import { getLocalStorageValues, TableLocalStorageKey } from "../helpers"
import { useTableContext } from "../provider"
import { ITableColumn } from "../types"

export const useColumnsVisibility = () => {

  const ctx  = useTableContext()
  const { tableId } = ctx.props
  const { combinedColumns } = ctx.columns.state

  useEffect(() => {

    // Calculate visible and customizable columns

    const model: VisibilityModel = {
      customizable: [],
      visibility: getLocalStorageValues(tableId, TableLocalStorageKey.visibleColumns) || {}
    }

    const { customizable, visibility } = combinedColumns.reduce(
      (result, item, index) => {
        if (item.hidden) return result

        if (isNil(result.visibility[item.field])) {
          result.visibility[item.field] = item.default ?? false
        }

        result.customizable.push(item)
        const lastIndex = result.customizable.length - 1

        result.customizable[lastIndex].index = lastIndex

        return result
      },
      model,
    )

    ctx.columns.api.updateVisible(visibility)
    ctx.columns.api.setCustomizable(customizable)

  }, [combinedColumns])

  return {}
}

interface VisibilityModel {
  customizable: ITableColumn[];
  visibility: IColumnsVisibility;
}
